import {AddCircleOutline as AddIcon} from '@material-ui/icons';
import Axios from 'axios';
import MaterialTable from 'material-table';
import React, {useEffect, useState} from 'react';
import PopupForm from '../utils/PopupForm';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import AddClassroomForm from '../AdminAddClassroomForm';
import TableTitle from '../utils/TableTitle';

export function AdminClassroomTable() {
  const [classrooms, setClassrooms] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const columns = [
    {title: 'Name', field: 'name'},
    {title: 'Teacher Email', field: 'teacher.email'},
    {title: 'Signup Code', field: 'signupCode'},
    {
      title: 'Archived',
      field: 'isArchived',
      type: 'boolean',
      initialEditValue: false,
      emptyValue: false,
    },
  ];

  useEffect(() => {
    const getClassrooms = async () => {
      const result = await Axios.get('/api/classroom');

      setClassrooms(result.data);
    };
    getClassrooms();
  }, []);

  return (
    <div style={{maxWidth: '100%'}}>
      <MaterialTable
        localization={tableLocalization}
        options={{draggable: false}}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: 'Add Classroom',
            isFreeAction: true,
            onClick: () => setAddOpen(true),
          },
        ]}
        title={<TableTitle>{'STEMhero Classrooms'}</TableTitle>}
        columns={columns}
        data={classrooms}
        icons={tableIcons}
      />
      <PopupForm
        component={AddClassroomForm}
        title="Create Classroom"
        open={addOpen}
        onClose={() => setAddOpen(false)}
      />
    </div>
  );
}
